import * as jsPDF from 'jspdf';
import { storage, db } from "common/config/Firebase"
import createPDFSignUseCase from "tasks/services/sign/createPDFSignUseCaseNEW"

const sanitize = str =>
    (str || '')
        .toString()
        .trim()
        .replace(/\s+/g, '_')          // espacios → _
        .replace(/[\\/#?\[\]*]+/g, ''); // quita caracteres problemáticos para Storage

const showPDFSignUseCase = async (data, clientData, detailData, type, sign) => {
    let doc = new jsPDF('p', 'mm', [210, 297]);

    // 1) Leer configuración de empresa (área de reparación) desde Firestore
    let appSettings = {};
    try {
        const snap = await db.collection('meta').doc('settings').get();
        if (snap.exists) {
            appSettings = snap.data();
        }
    } catch (e) {
        console.error('Error leyendo settings para el PDF', e);
        // si falla, appSettings se queda como {} y se usarán los valores por defecto
    }

    if (type === 1) {
        await createPDFSignUseCase(doc, data, clientData, detailData, type, sign, null, appSettings)
    } else if (type === 2) {
        const refSign = storage.ref().child(`${data.id}-1-sign.png`)
        const sign1 = await refSign.getDownloadURL()
        await createPDFSignUseCase(doc, data, clientData, detailData, type, sign1, sign, appSettings)
    } else if (type === 3 || type === 4) {
        const refSign = storage.ref().child(`${data.id}-1-sign.png`)
        const sign1 = await refSign.getDownloadURL().catch(ex => null)

        const refSign2 = storage.ref().child(`${data.id}-1-sign.png`)
        const sign2 = await refSign2.getDownloadURL().catch(ex => null)

        await createPDFSignUseCase(doc, data, clientData, detailData, type, sign1, sign2, appSettings)
    }

    if (type === 3) {
        const blob = doc.output('blob');
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
        setTimeout(() => URL.revokeObjectURL(url), 100);
        return
    }

    const refNumber = sanitize(data.reference);
    const clientName = sanitize(clientData?.name);

    const fileName = `INFORME-${refNumber}-${clientName}.pdf`;

    const ref = storage.ref().child(fileName);

    try {
        const uri = doc.output('datauristring')
        await ref.putString(uri, 'data_url')
    } catch (ex) {

    }

    const url = await ref.getDownloadURL()

    if (type === 4) {
        return url
    }

    const src = `https://mozilla.github.io/pdf.js/web/viewer.html?file=${url}#zoom=page-width`

    const iframe = document.getElementById('main-iframe')
    iframe.src = null
    iframe.src = src

    return new Promise((resolve, reject) =>
        iframe.onload = () => {
            resolve(url)
        }
    )
}

export default showPDFSignUseCase